import { render, staticRenderFns } from "./PiechartCardview.vue?vue&type=template&id=475d781a"
import script from "./PiechartCardview.vue?vue&type=script&lang=js"
export * from "./PiechartCardview.vue?vue&type=script&lang=js"
import style0 from "./PiechartCardview.vue?vue&type=style&index=0&id=475d781a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports